import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { PlansManagement } from '../../components/admin/PlansManagement';

export function PlansPage() {
  return (
    <AdminLayout
      title="Plans tarifaires"
      description="Gérez les offres et tarifs de la plateforme"
    >
      <PlansManagement />
    </AdminLayout>
  );
}
